var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup326(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_326",
    "data-name": "Group 326",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8.982,
    height: 11.975,
    viewBox: "0 0 8.982 11.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 8.982,
    height: 11.975,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M8.413,11.975H.569c-.046-.02-.094-.038-.139-.061A.713.713,0,0,1,0,11.257Q0,5.988,0,.718A.686.686,0,0,1,.063.436.818.818,0,0,1,.569,0H5.238c0,.058.008.116.008.175q0,1.368,0,2.736a.755.755,0,0,0,.527.782,1.1,1.1,0,0,0,.323.041H8.828c.153,0,.154,0,.154.157q0,3.677,0,7.354a.735.735,0,0,1-.213.515.952.952,0,0,1-.356.215M5.994,7.86q0,1.227,0,2.454c0,.153,0,.156.158.156.393,0,.785,0,1.178,0,.107,0,.142-.034.141-.142q0-2.472,0-4.944c0-.109-.037-.141-.143-.14-.393,0-.785,0-1.178,0-.154,0-.157,0-.157.157q0,1.227,0,2.454m-.765.747q0-.853,0-1.706c0-.153,0-.155-.159-.155-.393,0-.785,0-1.178,0-.107,0-.142.034-.141.142q0,1.724,0,3.447c0,.109.038.141.143.14.4,0,.793-.005,1.189,0,.113,0,.148-.035.147-.148,0-.573,0-1.145,0-1.718m-3.717.738c0,.331,0,.662,0,.993,0,.1.036.135.136.134q.606-.006,1.212,0c.095,0,.131-.03.131-.128q0-.987,0-1.974c0-.1-.035-.129-.13-.128q-.606.005-1.212,0c-.1,0-.138.031-.137.134,0,.323,0,.646,0,.969",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M191.655,0l2.829,2.836c.022.022.045.043.066.066s.057.041.046.075-.053.024-.082.024h-2.777c-.075,0-.115-.019-.114-.1q0-1.426,0-2.853A.3.3,0,0,1,191.631,0Z",
    transform: "translate(-185.646)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup326);
export default __webpack_public_path__ + "static/media/Group326.4d9216731fc3514ada006d832ed93da0.svg";
export { ForwardRef as ReactComponent };